import * as React from 'react';
import { Image } from '../../types';
import {
  FacebookShareButton,
  LinkedinShareButton,
  TwitterShareButton,
} from 'react-share';
import facebookSvg from '../../img/facebook.svg';
import linkedinSvg from '../../img/linkedin.svg';
import twitterSvg from '../../img/twitter.svg';
import Text from './Text';
import s from './ShareGroup.module.scss';

interface Props {
  link: string;
  text: string;
  desktop: boolean;
}

interface State {
  socialMediaBlockFixed: boolean;
}

class ShareGroup extends React.Component<Props, State> {
  state = {
    socialMediaBlockFixed: false,
  };
  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);
  }
  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }
  handleScroll = () => {
    const currentScrollPos = window.pageYOffset;
    const fixed = currentScrollPos >= window.innerHeight * 0.35; // 0.35 is the height of the hero.

    this.setState({
      socialMediaBlockFixed: fixed,
    });
  };
  render() {
    const { link, text, desktop } = this.props;
    const { socialMediaBlockFixed } = this.state;

    const classes = [];
    if (desktop) {
      const positionClass = socialMediaBlockFixed ? s.fixed : s.absolute;
      classes.push(
        s.socialSharingBlockLarge,
        'd-none d-sm-block',
        positionClass
      );
    } else {
      classes.push('d-block d-sm-none');
    }
    return (
      <div className={classes.join(' ')}>
        <Text label>Share</Text>
        <div className={!desktop ? s.socialSharingBlockSmall : null}>
          <FacebookShareButton
            className={`${s.socialMediaButton} ${s.facebook}`}
            quote={text}
            url={link}
          >
            <img src={facebookSvg} />
          </FacebookShareButton>
          <LinkedinShareButton
            url={link}
            className={`${s.socialMediaButton} ${s.linkedin}`}
          >
            <img src={linkedinSvg} />
          </LinkedinShareButton>
          <TwitterShareButton
            url={link}
            title={text}
            className={`${s.socialMediaButton} ${s.twitter}`}
          >
            <img src={twitterSvg} />
          </TwitterShareButton>
        </div>
      </div>
    );
  }
}

export default ShareGroup;
